import UserAuthentication from '@/auth'

function isCoach(account) {
  try {
    return isLeadershipOrCoach(account)
  } catch (error) {
    return false
  }
}

function isFinancialCoach(account) {
  return isLeadership(account) || account.canDoFinancialValidation
}

function isSiteAdmin(account) {
  return Boolean(account?.isSiteAdmin)
}

function isOrganizationAdmin(account) {
  return Boolean(account?.isOrganizationAdmin || account?.isAdmin)
}

function isAdmin(account) {
  return Boolean(account?.isAdmin)
}

function isAIAdmin(account) {
  return Boolean(account?.isAdmin && account?.isReverAIAdmin)
}

function isOrganizationAIManager(account) {
  return Boolean(account?.isOrganizationAIManager)
}

function isLoggedIn() {
  const auth = new UserAuthentication(window.localStorage)
  return auth.isLoggedIn()
}

function isLeadership(account) {
  return account.isAdmin || account.isOrganizationAdmin || account.isSiteAdmin
}

function isLeadershipOrCoach(account) {
  return (
    account.isAdmin ||
    account.isOrganizationAdmin ||
    account.isSiteAdmin ||
    account.isCoach
  )
}

function isLeadershipOrFinancialCoach(account) {
  return (
    account.isAdmin ||
    account.isOrganizationAdmin ||
    account.isSiteAdmin ||
    account.canDoFinancialValidation
  )
}

function isLeadershipOrCoachOrFinancialCoach(account) {
  return (
    account.isAdmin ||
    account.isOrganizationAdmin ||
    account.isSiteAdmin ||
    account.isCoach ||
    account.canDoFinancialValidation
  )
}

function isFeatureEnabled(organization, featureName) {
  const fieldName = `featuresEnabled__${featureName}`
  return Boolean(organization?.[fieldName])
}

function aclsAllowedByPlan(organization, acl) {
  const aclAllowedByPlan = {
    essentials: [
      'stream',
      'challenges',
      'people',
      'teams',
      'validations',
      'insights',
      'site-settings',
    ],
    business: [
      'stream',
      'challenges',
      'people',
      'teams',
      'validations',
      'insights',
      'audit-logs',
      'reports',
      'ai-settings',
    ],
    enterprise: [
      'site-settings',
      'sites',
      'stream',
      'challenges',
      'people',
      'teams',
      'validations',
      'insights',
      'audit-logs',
      'reports',
      'ai-settings',
    ],
  }

  const { plan } = organization
  return aclAllowedByPlan[plan]?.includes?.(acl)
}

function aiFeaturesAreEnabled(account, organization) {
  const organizationHasAIFeatures = isFeatureEnabled(
    organization || account.organization,
    'aiFeatures'
  )

  const aiFeaturesAreEnabledForAllUsers = Boolean(
    organization?.aiSettings?.canAllUsersUseAIFeatures
  )

  const userHasAccessToAIFeatures =
    aiFeaturesAreEnabledForAllUsers ||
    account?.site?.canUseAIFeatures ||
    account?.canUseAIFeatures ||
    account.isOrganizationAIManager ||
    account.isReverAIAdmin

  return Boolean(organizationHasAIFeatures && userHasAccessToAIFeatures)
}

const access = {
  aclsAllowedByPlan,
  aiFeaturesAreEnabled,
  isLoggedIn,
  isCoach,
  isOrganizationAdmin,
  isAdmin,
  isSiteAdmin,
  isLeadership,
  isLeadershipOrCoach,
  isFinancialCoach,
  isFeatureEnabled,
  isLeadershipOrCoachOrFinancialCoach,
  isLeadershipOrFinancialCoach,
  isAIAdmin,
  isOrganizationAIManager,
}

export default access
